import React, { Fragment } from "react";

import {
  CategoryItem,
  CatelogItem,
  CurrentCatalogItem,
  getItemsImages,
  StatusBar,
  ShippingRanges,
} from "./functions";
import Loading from "../assets/Loading";
import process from "process";
import { Button } from "@material-ui/core";
import { Menu } from "@mui/icons-material";

const development =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

class GiftShopHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scriptsLoaded: false,
      loading: <Loading />,
      items: [],
      item_variations: [],
      taxes: [],
      images: [],
      categories: [],
      shipping_items: {},
      cartItems: {},
      exlcudedCategories: [
        "Farm Tours",
        "Virtual Tours and Appearances",
        "Shearing",
        "Treks with a llama",
        "Sponsorship ",
        "* General",
        "Shipping",
        "Emily Kane",
        "Experiences",
        "Gift Certificate",
      ],
      categoryMenuOpen: true,
    };
  }

  componentDidMount() {
    console.log(`Dev? ${development}`);
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://web.squarecdn.com/v1/square.js";
    script.onload = () => {
      this.setState({ scriptsLoaded: true });
    };

    //For head
    document.head.appendChild(script);

    // Get Giftshop Items from Square
    this.getAllItems();
  }

  getAllItems() {
    fetch("/giftshop-api/", {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);

        var items = data.items.filter(
          (i) => i.type == "ITEM" && i.item_data.ecom_available == true
        );
        console.log(
          data.items.filter(
            (i) =>
              i.type == "CATEGORY" && i.category_data.name.includes("Shipping")
          )
        );
        let categories = data.items
          .filter(
            (i) =>
              i.type == "CATEGORY" &&
              !this.state.exlcudedCategories.includes(i.category_data.name)
          )
          .sort(function (a, b) {
            if (
              a.category_data.name.toLowerCase() <
              b.category_data.name.toLowerCase()
            )
              return -1;
            if (
              a.category_data.name.toLowerCase() >
              b.category_data.name.toLowerCase()
            )
              return 1;
            return 0;
          });
        this.setState({
          items: items,
          categories: categories,
          currentCategory: categories[0],
          variations: data.items.filter((i) => i.type == "ITEM_VARIATION"),
          images: data.items.filter((i) => i.type == "IMAGE"),
          taxes: data.items.filter((i) => i.type == "TAX"),
          shipping_items: this.collectShippingItems(
            data.items.filter((i) => i.type == "ITEM")
          ),
          loading: null,
        });

        this.setCategory(categories[0]);
      });
  }

  collectShippingItems(items) {
    var shipping_items = {};
    console.log("SHIPPING");
    console.log(this.state.categories);
    console.log(ShippingRanges);
    items.forEach((element) => {
      if (element.item_data.name.includes("Shipping")) {
        console.log(element.item_data.category_id);
        console.log(ShippingRanges[element.item_data.category_id]);
        element.shipping_range = ShippingRanges[element.item_data.category_id];
        shipping_items[element.id] = element;
      }
    });
    console.log(shipping_items);
    return shipping_items;
  }

  setCategory(category) {
    this.setState({ currentCategory: category, categoryMenuOpen: false });
  }

  setItem(item) {
    console.log(item);
    this.setState({
      currentItem:
        item != null ? (
          <CurrentCatalogItem
            item={item}
            variations={this.state.variations.filter((v) =>
              item.item_data.variations.some((iv) => iv.id == v.id)
            )}
            images={this.state.images}
            onClose={this.setItem.bind(this)}
            onAddedToCart={(itemData) => {
              this.setState({
                cartItems: {
                  ...this.state.cartItems,
                  [itemData.id]: {
                    ...this.state.cartItems[itemData.id],
                    itemData,
                    variations: this.addVariation(
                      itemData.id,
                      itemData.variation,
                      itemData.qty,
                      itemData.inStock
                    ),
                  },
                },
              });
            }}
          />
        ) : (
          ""
        ),
    });
  }

  addVariation = (itemId, variation, qty, maxQty) => {
    variation.qty = qty;
    if (
      this.state.cartItems[itemId] &&
      this.state.cartItems[itemId].variations.some((v) => v.id == variation.id)
    ) {
      var index = this.state.cartItems[itemId].variations.findIndex(
        (v) => v.id == variation.id
      );
      console.log(index);
      variation.qty += this.state.cartItems[itemId].variations[index].qty;
      if (variation.qty > maxQty) {
        variation.qty = maxQty;
      }
      var currentVariations = this.state.cartItems[itemId].variations;
      currentVariations.splice(index, 1, variation);
      return currentVariations;
    } else {
      variation.stock = maxQty;
      if (this.state.cartItems[itemId]) {
        return [...this.state.cartItems[itemId].variations, variation];
      } else {
        return [variation];
      }
    }
  };

  render() {
    return (
      <Fragment>
        {/* <Helmet>
          <title>Gift Shop - Dakota Ridge Farm</title>
          <meta
            name="description"
            content="Welcome to our gift shop! We have a lot of Llama themed goodies including some items directly related to the farm."
          />
        </Helmet> */}
        {this.state.loading}
        <StatusBar
          currentCategory={this.state.currentCategory}
          cartItems={this.state.cartItems}
          shippingItems={this.state.shipping_items}
          scriptsLoaded={this.state.scriptsLoaded}
        />
        <span className="shop-top-message">
          Gift Certificates Available{" "}
          <a className="site-link" href="/gift-certificates">
            <strong>HERE</strong>
          </a>
        </span>
        <div
          className="categories-menu-button"
          onClick={() => {
            this.setState({ categoryMenuOpen: !this.state.categoryMenuOpen });
          }}
        >
          {this.state.categoryMenuOpen ? (
            "X Close"
          ) : (
            <Button startIcon={<Menu />} style={{ fontSize: "2rem" }}>
              Menu
            </Button>
          )}
        </div>
        <div
          className={`category-menu-container ${
            this.state.categoryMenuOpen ? "category-menu-container-active" : ""
          }`}
        >
          <span className="shop-menu-title">Categories</span>
          {this.state.categories
            .filter(
              (item) =>
                !this.state.exlcudedCategories.some((e) =>
                  item.category_data.name.includes(e)
                )
            )
            .map((c) => {
              return (
                <CategoryItem
                  category={c}
                  onSetCategory={this.setCategory.bind(this)}
                  selected={
                    this.state.currentCategory &&
                    this.state.currentCategory.id == c.id
                  }
                />
              );
            })}
        </div>
        <div className="items-container">
          {this.state.currentCategory != null
            ? this.state.items
                .filter(
                  (item) =>
                    item.item_data.category_id == this.state.currentCategory.id
                )
                .map((i) => {
                  return (
                    <CatelogItem
                      item={i}
                      images={getItemsImages(i, this.state.images)}
                      onItemSelected={this.setItem.bind(this)}
                    />
                  );
                })
            : ""}
        </div>
        {this.state.currentItem}
      </Fragment>
    );
  }
}

export default GiftShopHome;
